import React from 'react';
import Orders from './orders/Orders';
import CreateOrderLink from '../../common/CreateOrderLink';
import DeliveryCutoffs from './delivery-cutoffs/DeliveryCutoffs';
import MinimumOrderQuantities from './moq/MinimumOrderQuantities';

export default function MyOrders() {
    return (
        <div>
            <div className={'page-header'}>
                <div className={'content'}>
                    <div className={'page-header-container flex'}>
                        <h1>My Orders</h1>
                        <DeliveryCutoffs />
                        <MinimumOrderQuantities />
                        <CreateOrderLink />
                    </div>
                </div>
            </div>
            <Orders />
        </div>
    );
}
